<template>
<div>
    <validation-observer v-slot="{ invalid }">
        <h3 class="mb-0">MAKLUMAT PERUBAHAN TPG</h3>
        <br />
        <div class="pl-lg-2">
            <b-row>
                <b-col sm="1"></b-col>
            </b-row>
            <validation-provider name="Klasifikasi Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                <b-row>
                    <b-col lg="5"> Klasifikasi Perkhidmatan </b-col>
                    <b-col lg="1"> :</b-col>
                    <b-col lg="6">
                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjPerGajiBiasa.ServClassId" :options="ServClassList" @change="runMethod()" style="width: 150%" aria-describedby="input-2-live-feedback">
                            <template #first>
                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </validation-provider>
            <br />
            <validation-provider name="Skim Perkhidmatan" :rules="{ required: true }" v-slot="validationContext">
                <b-row>
                    <b-col lg="5"> Skim Perkhidmatan</b-col>
                    <b-col lg="1"> :</b-col>
                    <b-col lg="6">
                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjPerGajiBiasa.SchmOfServId" :options="SchmOfServList" @change="runMethod2()" style="width: 150%" aria-describedby="input-2-live-feedback">
                            <template #first>
                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </validation-provider>
            <br />
            <validation-provider name="Gred Jawatan Lantikan Pertama" :rules="{ required: true }" v-slot="validationContext">
                <b-row class="my-1">
                    <b-col lg="5"> Gred Jawatan </b-col>
                    <b-col lg="1">:</b-col>
                    <b-col lg="6">
                        <b-form-select id="Klasifikasi Perkhidmatan" name="Klasifikasi Perkhidmatan" value-field="value" text-field="text" v-model="ObjPerGajiBiasa.SalGrdID" :options="SalGrdList" style="width: 40%" aria-describedby="input-2-live-feedback">
                            <template #first>
                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </validation-provider>
            <br/>
            <validation-provider name="Tarikh Kenaikan Pangkat" :rules="{ required: true }" v-slot="validationContext">
                <b-row class="my-1">
                    <b-col sm="5"> Tarikh Kenaikan Pangkat * </b-col>
                    <b-col sm="1">:</b-col>
                    <b-col sm="6">
                        <base-input type="date" v-model="ObjPerGajiBiasa.tkhKenaikanPangkat" />
                    </b-col>
                </b-row>
            </validation-provider>
            <br />
            <validation-provider name="Tarikh Pergerakan Gaji (TPG)" :rules="{ required: true }" v-slot="validationContext">
                <b-row class="my-1">
                    <b-col sm="5"> Tarikh Pergerakan Gaji (TPG) selepas Kenaikan Pangkat *  </b-col>
                    <b-col sm="1">:</b-col>
                    <b-col sm="6">
                        <b-form-select id="Tarikh Pergerakan Gaji (TPG)" name="Tarikh Pergerakan Gaji (TPG)" value-field="value" text-field="text" v-model="ObjPerGajiBiasa.TPGid" :options="tpgList" style="width: 60%" aria-describedby="input-2-live-feedback">
                            <template #first>
                                <b-form-select-option :value="null">-- Pilihan --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>
            </validation-provider>
            <br />
            <validation-provider name="Tarikh Kuatkuasa" :rules="{ required: true }" v-slot="validationContext">
                <b-row class="my-1">
                    <b-col sm="5"> Tarikh Kuatkuasa* </b-col>
                    <b-col sm="1">:</b-col>
                    <b-col sm="6">
                        <base-input type="date" v-model="ObjPerGajiBiasa.EftDate" />
                    </b-col>
                </b-row>
            </validation-provider>
            <b-col>&nbsp;</b-col>
            <b-form-row>
                <b-col>
                    <b-form-group>
                        <div>
                            <b-col>&nbsp;</b-col>
                            <b-col align="center">
                                <b-button variant="success" type="submit">SIMPAN</b-button>
                                <!-- <b-button size="md" variant="primary" v-show="active" @click="next()">KEMBALI</b-button>
                                                <b-button size="md" variant="primary" v-show="active" @click="next()">SETERUSNYA</b-button> -->
                                <!-- <b-button size="md" variant="primary" v-show="active" @click="nextPapar()">PAGE PAPAR</b-button> -->

                            </b-col>
                        </div>
                    </b-form-group>
                </b-col>
            </b-form-row>
        </div>
    </validation-observer>
</div>
</template>

<script>
import moment from "moment";
import Store from "@/store";
import GetselenggaraService from "@/services/selenggaraService.js";
export default {
    data() {
        return {
            ObjPerGajiBiasa: {},
            ServClassList: [],
            SchmOfServList: [],
            SalGrdList: [],
            tpgList: [],
        }
    },
    methods: {
        getValidation({
            dirty,
            validated,
            valid = null
        }) {

            return dirty || validated ? valid : null;
        },
        runMethod() {
            console.log(this.ServClassId);

            let Search = {
                ServClassId: this.ObjLantikanSblm2003.ServClassId,
            };

            GetselenggaraService.getSenaraiSchmOfServ(Search)
                .then((resp) => {
                    this.SchmOfServList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        runMethod2() {
            console.log("this SchmOfServId", this.SchmOfServId);
            let Search2 = {
                ServClassId: this.ObjLantikanSblm2003.ServClassId,
                SchmOfServId: this.ObjLantikanSblm2003.SchmOfServId,
            };
            console.log("this Search2", this.Search2);
            GetselenggaraService.getSenaraiSalGrd(Search2)
                .then((resp) => {
                    this.SalGrdList = resp.data;
                    //console.log(this.objekList);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() {

        GetselenggaraService.getSenaraiServClass()
            .then((resp) => {
                this.ServClassList = resp.data;
                //console.log(this.objekList);
            })
            .catch((err) => {
                console.log(err);
            });

        GetselenggaraService.getTPG()
            .then((resp) => {
                this.tpgList = resp.data;
                console.log("tpgList", this.tpgList);
            })
            .catch((err) => {
                console.log(err);
            });
    }
}
</script>
